
export interface ISignal<S,T> {
    on(handler: (source: S, data: T) => void): void;
    off(handler: (source: S, data: T) => void): void;
}

export default class Signal<S, T> implements ISignal<S,T> {
    private handlers: Array<(source: S, data: T) => void> = [];

    public on(handler: (source: S, data: T) => void): void {
        this.handlers.push(handler);
    }

    public off(handler: (source: S, data: T) => void): void {
        this.handlers = this.handlers.filter(h => h !== handler);
    }

    public trigger(source: S, data: T): void {
        this.handlers.slice(0).forEach(h => h(source, data));
    }

    public expose(): ISignal<S,T> {
        return this
    }
}

// https://www.davideaversa.it/blog/simple-event-system-typescript/

/* 
class Dog {
    private readonly onBark = new Signal<Dog, string>();
	constructor(readonly name: string) {}
    
    public get BarkEvent(): ISignal<Dog, string> {
        return this.onBark.expose();
    }
	
	public sayWof() {
		this.onBark.trigger(this, "WOF!");
	}

	public sayAnything(message: string) {
		this.onBark.trigger(this, message);
	}
}

class DogListener {

	constructor(dog: Dog) {
		let dogBarkHandler = (s: Dog, bark: string) => {
			console.log(`Listener: Dog "${dog.name}" barked: ${bark}`);
		}
		dog.BarkEvent.on(dogBarkHandler);

        // NOW I MAKE THE DOG BARK!
        dog.BarkEvent.trigger(dog, "FAKE WOOF!")
	}
	
}

const apollo = new Dog("Apollo");
const apolloListener = new DogListener(apollo);

apollo.sayWof()
*/